import type { ReactNode } from "react";

/** Consistent line-art size for sidebar navigation icons (Figma). */
export const SIDEBAR_MENU_ICON_CLASS =
	"sidebar-menu-icon flex shrink-0 items-center [&>.MuiSvgIcon-root]:text-[1.375rem]";

export function sidebarMenuIcon(icon: ReactNode): ReactNode {
	return <span className={SIDEBAR_MENU_ICON_CLASS}>{icon}</span>;
}
